import { styled, css } from 'styled-components'
import { MATERIAL_TYPES, MATTING } from '@mixtiles/web-backend-shared'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const Frame = styled.img`
  width: 100%;
  height: 100%;
  user-select: none;
  -webkit-user-drag: none;
`

type mattingStylingProps = {
  $matting: MATTING
  $materialType: MATERIAL_TYPES
}

function mattingStyling({ $matting }: mattingStylingProps) {
  switch ($matting) {
    case MATTING.SHALLOW:
      return css`
        transform: scale(0.8);
      `
    case MATTING.MEDIUM:
      return css`
        transform: scale(0.6);
      `
    case MATTING.DEEP:
      return css`
        transform: scale(0.5);
      `
    case MATTING.NONE:
    default:
      return css`
        transform: scale(1);
      `
  }
}

// Positioning is different for classic and wide frame - the values were calculated manually from assets
function positionStyling({ $materialType }: mattingStylingProps) {
  if ($materialType === MATERIAL_TYPES.CLASSIC) {
    return css`
      left: 10%;
      top: 7.55%;
      width: 80.35%;
      height: 84.7%;
    `
  } else {
    return css`
      left: 15.3%;
      top: 11.5%;
      width: 70.35%;
      height: 76.5%;
    `
  }
}

export const Image = styled.img<mattingStylingProps>`
  position: absolute;
  object-fit: cover;
  mix-blend-mode: darken;
  user-select: none;
  -webkit-user-drag: none;

  ${mattingStyling};
  ${positionStyling};
`
